'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transforms the Squiz response into a data model
 * @param {Object} data The data response from Squiz
 * @returns {Map} The data model
 */
var transformTranslationTokenData = function transformTranslationTokenData(data) {
    var resp = {
        logo: {},
        login: {},
        register: {},
        deposit: {},
        account: {},
        search: {}
    };

    (0, _keys2.default)(data).forEach(function (key) {
        var name = key.split('.').shift();
        var desc = key.split('.').pop();

        resp[name] = (0, _extends4.default)({}, resp[name], (0, _defineProperty3.default)({}, desc, data[key]));
    });

    return (0, _immutable.Map)(resp);
};
exports.default = transformTranslationTokenData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/translation-token/model.js
// module id = 258
// module chunks = 0